<template>
  <div
    class="t3m-ImageMap-hotspot"
    :class="`t3m-ImageMap-hotspot--${appearance}`"
    :style="style"
    @click="selectHotspot(specs)"
  >
    <div class="t3m-ImageMap-hotspot-inner">
      <div class="t3m-ImageMap-hotspot-index">
        {{ idLeadingZero(specs.id, 2) }}
      </div>
      <div class="t3m-ImageMap-hotspot-title">{{ specs.title }}</div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "t3mHotspot",
  props: {
    specs: Object,
    appearance: {
      type: String,
      default: "spot",
    },
  },
  computed: {
    style: function () {
      return this.appearance === "spot"
        ? `left: ${this.specs.x}; top: ${this.specs.y};`
        : undefined;
    },
  },
  methods: {
    ...mapActions(["selectHotspot"]),
    idLeadingZero: function (num, size) {
      num = num.toString();
      while (num.length < size) num = "0" + num;
      return num;
    },
  },
};
</script>
